import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=3af2f542&scoped=true"
import script from "./navmenu.vue?vue&type=script&lang=ts"
export * from "./navmenu.vue?vue&type=script&lang=ts"
import style0 from "./navmenu.vue?vue&type=style&index=0&id=3af2f542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2f542",
  null
  
)

export default component.exports